import React, { useEffect } from "react";
import { Modal } from "../../ui/Modal/Modal";
import styles from "./ModalAddGoogleDrive.module.scss";
import AddFilesIcon from "../../assets/icons/AddFilesIcon";
import { GoogleDriveIcon } from "../../assets/icons/GoogleDriveIcon";
import { FileUpload } from "../../ui/FileUpload/FileUpload";

export const ModalAddGoogleDrive = ({
  visible,
  handleClose,
  driveFile,
  setDriveFile,
}) => {
  useEffect(() => {
    if (driveFile) {
      handleClose();
    }
  }, [driveFile, handleClose]);

  return (
    <Modal visible={visible} handleClose={handleClose}>
      <div className={styles.container}>
        <div className={styles.title}>
          Добавление <GoogleDriveIcon size={18} fill={"#000"} /> GoogleDrive
        </div>

        <div className={styles.form}>
          <FileUpload
            onFileSelected={setDriveFile}
            acceptedFileType="application/json"
            fileTypeErrorMessage="Неподдерживаемый файл! \n Выберите другой"
            inputId="upload_file_google"
            icon={<AddFilesIcon size={25} />}
            mainLabel="JSON-ключ"
            subLabel="Нажмите или перетащите файл сюда"
          />
        </div>
      </div>
    </Modal>
  );
};
